angular.module('sharecrf.environment', ['portal.i18n']);